import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

function RadioButtonLabel({ title }) {
  return (
    title && (
      <h2 className="beacon-radio-button-title">
        {title}
        <style jsx>{styles}</style>
      </h2>
    )
  );
}
function RadioButtonHintText({ hintText }) {
  return (
    hintText && (
      <h3 className="beacon-radio-button-hint-text">
        {hintText}
        <style jsx>{styles}</style>
      </h3>
    )
  );
}
function RadioButton({ id, buttonName, value, disabled, ariaLabel, checked, onChange }) {
  return (
    <div className="beacon-radio-button">
      <input
        className="beacon-radio-button-input"
        type="radio"
        aria-label={ariaLabel}
        id={id}
        name={buttonName}
        value={value}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor={id}>
        <p className="beacon-radio-button-label">{value}</p>
      </label>
      <style jsx>{styles}</style>
    </div>
  );
}

function RadioGroup({ title, hintText, options, role }) {
  let checkedButton = null;

  const optionsIsValid = Array.isArray(options);

  if (optionsIsValid && options.length > 2) {
    for (let i = 0; i < options.length; i++) {
      if (options[i].checked === true) {
        checkedButton = options[i].value;
        break;
      }
    }
  }

  const [selectedOption, setSelectedOption] = useState(checkedButton);

  const onOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div className="beacon-radio-button-group beacon-container">
      <div className="beacon-radio-button-title-wrapper">
        <RadioButtonLabel title={title} />
        <RadioButtonHintText hintText={hintText} />
      </div>
      <div role={role}>
        {optionsIsValid &&
          options.map((d) => (
            <RadioButton
              aria-label={d.ariaLabel}
              id={d.id}
              name={d.buttonName}
              value={d.value}
              disabled={d.disabled}
              key={d.id}
              checked={selectedOption === d.value}
              onChange={onOptionChange}
            />
          ))}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}

RadioGroup.defaultProps = {
  title: null,
  hintText: null,
  role: 'radio-group',
  options: PropTypes.arrayOf(
    PropTypes.shape({
      ariaLabel: 'Radio Button',
      checked: false,
    }),
  ),
};

const RadioGroupShape = {
  ariaLabel: PropTypes.string,
  id: PropTypes.string.isRequired,
  buttonName: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
};

RadioGroup.propTypes = {
  title: PropTypes.string,
  hintText: PropTypes.string,
  role: PropTypes.string,
  options(props, propName, componentName) {
    const tempArray = props[propName];
    if (!Array.isArray(tempArray)) return new Error(`${propName} must be an array when passed into ${componentName}`);
    if (tempArray.length < 2) return new Error(`${propName} must have at least two radio button options`);

    tempArray.forEach((elem) => PropTypes.checkPropTypes(RadioGroupShape, elem, 'prop', 'myComponent'));
    return null;
  },
};

export default RadioGroup;
